import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ComparisonTool = ({ comparisonTracks, onRemoveTrack, onClearAll }) => {
  if (comparisonTracks?.length === 0) {
    return (
      <div className="bg-card border border-border rounded-lg p-8 text-center animate-fade-in">
        <Icon name="GitCompare" size={48} className="text-muted-foreground mx-auto mb-4" />
        <h3 className="text-lg font-medium text-foreground mb-2">Comparateur de Filières</h3>
        <p className="text-muted-foreground text-sm">
          Sélectionnez jusqu'à 3 filières pour analyser leurs différences (matières, débouchés, difficulté).
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden animate-fade-in-up shadow-sm">
      {/* Header */}
      <div className="p-4 bg-muted/30 border-b border-border flex items-center justify-between">
        <h3 className="text-lg font-medium text-foreground flex items-center">
          <Icon name="GitCompare" size={20} className="mr-2 text-primary" />
          Comparatif ({comparisonTracks?.length}/3)
        </h3>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={onClearAll}
          iconName="X"
          className="text-muted-foreground hover:text-red-600 hover:bg-red-50"
        >
          Effacer tout
        </Button>
      </div>
      
      {/* Comparison Grid */}
      <div className="p-6">
        <div className={`grid gap-6 ${
          comparisonTracks?.length === 1 ? 'grid-cols-1' : 
          comparisonTracks?.length === 2 ? 'grid-cols-1 md:grid-cols-2': 'grid-cols-1 md:grid-cols-3'
        }`}>
          {comparisonTracks?.map((track) => (
            <div key={track?.id} className="space-y-4 relative">
              
              {/* Track Header */}
              <div className="flex items-center justify-between pb-2 border-b border-border/50">
                <div className="flex items-center space-x-3">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center shadow-sm ${track?.color}`}>
                    <Icon name={track?.icon} size={16} color="white" />
                  </div>
                  <h4 className="font-semibold text-foreground text-sm leading-tight">{track?.name}</h4>
                </div>
                <button
                  onClick={() => onRemoveTrack(track?.id)}
                  className="p-1.5 hover:bg-red-50 hover:text-red-600 rounded-full transition-colors"
                  aria-label="Retirer"
                >
                  <Icon name="X" size={14} />
                </button>
              </div>

              {/* Difficulty Badge */}
              <div>
                <div className="text-xs uppercase tracking-wider font-semibold text-muted-foreground mb-1">Difficulté</div>
                <div className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${
                  track?.difficulty === 'Élevé' ? 'text-red-700 bg-red-50 border-red-100' :
                  track?.difficulty === 'Moyen'? 'text-amber-700 bg-amber-50 border-amber-100' : 'text-green-700 bg-green-50 border-green-100'
                }`}>
                  {track?.difficulty}
                </div>
              </div>

              {/* Key Subjects */}
              <div>
                <div className="text-xs uppercase tracking-wider font-semibold text-muted-foreground mb-2">Matières Dominantes</div>
                <ul className="space-y-1">
                  {track?.subjects?.slice(0, 4)?.map((subject, index) => (
                    <li key={index} className="text-sm text-foreground flex items-start">
                      <span className="text-primary mr-2">•</span> {subject}
                    </li>
                  ))}
                  {track?.subjects?.length > 4 && (
                    <li className="text-xs text-muted-foreground pl-3 italic">
                      +{track?.subjects?.length - 4} autres...
                    </li>
                  )}
                </ul>
              </div>

              {/* Top Careers */}
              <div>
                <div className="text-xs uppercase tracking-wider font-semibold text-muted-foreground mb-2">Débouchés</div>
                <ul className="space-y-1">
                  {track?.careerProspects?.slice(0, 3)?.map((career, index) => (
                    <li key={index} className="text-sm text-foreground flex items-start">
                      <Icon name="ArrowRight" size={12} className="mt-1 mr-2 text-secondary" /> 
                      {career}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Statistics (With Disclaimer) */}
              <div className="pt-3 mt-2 border-t border-border">
                <div className="grid grid-cols-2 gap-2">
                    <div className="text-center p-2 bg-muted/20 rounded-lg">
                    <div className="text-lg font-bold text-primary">{track?.statistics?.successRate}</div>
                    <div className="text-[10px] text-muted-foreground uppercase">Taux Réussite*</div>
                    </div>
                    <div className="text-center p-2 bg-muted/20 rounded-lg">
                    <div className="text-lg font-bold text-secondary">{track?.statistics?.employmentRate}</div>
                    <div className="text-[10px] text-muted-foreground uppercase">Insertion Pro*</div>
                    </div>
                </div>
                <div className="text-[10px] text-muted-foreground text-center mt-2 italic">
                    * Estimations basées sur les tendances nationales
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ComparisonTool;